export enum VehicleStatus {
    INACTIVE = '1001',
    VACATION = '1002',
    MAINTENANCE = '1003',
    SUSPENDED = '1004',
    OPERATING = '1005',
    RETENTION = '1006', 
    RENOVATION = '1007',
    RESERVE = '1008',
    RETAIN = '1009'
  }